export default {
  message: {
    welcome: "Willkommen zurück",
    fill_form_below: "Bitte füllen Sie das folgende Formular aus",
    check_email_for_code: "Überprüfen Sie Ihre E-Mails auf Kabeljaue",
    logout: "Ausloggen",
    are_you_sure: "Bist du sicher?",
    page_not_found: "Seite nicht gefunden",
    please_select_country: "Bitte wählen Sie zuerst ein Land aus",
    goto_page: "Gehe zu Seite",
    prev_page: "Vorherige Seite",
    next_page: "Nächste Seite",
    success: "Erfolg",
    no_data: "Es sind keine Daten zum Anzeigen vorhanden",
    choose_image: "Bild auswählen ...",
    choose_images: "Bilder auswählen ...",
    change_image: "Bild ändern ...",
    remove_image: "Entferne Bild",
    load_more: "Mehr laden",
    choose_color: "Wähle eine Farbe",
    edit_dimension: "Dimension bearbeiten",
    create_dimension: "Dimension erstellen",
    set_dimension_price: "Maß und Preis einstellen",
    update_dimension_price: "Update Dimension und Preis",
    set_color_dimension_price: "Stellen Sie Farbe, Abmessung und Preis ein",
    add_colors_prices: "Fügen Sie Farben und Preise hinzu",
    add_images_prices: "Fügen Sie Bilder und Preise hinzu",
    other_color_dimensions: "Andere Maße von dieser Farbe",
    coming_soon: "Demnächst",
    landing_description: "Die digitale Aufmass-App",
    landing_title: "Einfach - Schnell - Messen",
    landing_detailed_description:
      "Der Mess-Assistent für den gewerblichen Handwerker:",
    landing_jobs:
      "Glaser, Fensterbauer, Tischler, Monteure, Metallbauer, Bodenleger, Installateure, Fliesenleger ...",
    footer_text: "Kontakt<br>Impressum<br>Datenschutz",
    upload_images: "Bilder hochladen",
    images_size_error:
      "Bildgröße überschritten. Bitte versuchen Sie, diesen Upload auf mehrere Uploads aufzuteilen."
  },

  page: {
    login: "Anmeldung",
    reset_password: "Passwort zurücksetzen",
    reclamations: "Reklamationen",
    taxes: "Steuern",
    orders: "Aufträge",
    dashboard: "Dashboard",
    industries: "Lieferanten",
    users: "Kunden",
    products: "Produkte",
    glass: "Glas",
    stone: "Stein",
    wood: "Holz",
    edge_processing: "Kantenbearbeitung",
    hole_drilling: "Lochbohren",
    corner_cutout: "Eckausschnitt",
    inner_cutout: "Ausschnitte",
    corner_section: "Eckabschnitt",
    glass_single: "Einfachglas, Tür und Spiegel",
    glass_insulating: "Isolierglas",
    glass_shower: "Duschglas",
    create_variant: "Variante anlegen",
    create_edge_processing: "Kantenbearbeitung erstellen",
    fittings: "Beschläge",
    equipment: "Ausrüstung",
    metal: "Metall",
    metal_balcony_rails: "Balkongeländer",
    metal_posts: "D-Balkongeländer",
    metal_clamps: "D-System für rahmenlose Ganzglasgeländer",
    hand_sanitizer: "Handdesinfektionsmittel",
    digital_printing: "Digitales Drucken"
  },

  form: {
    register: "Registrieren",
    submit: "Speichern",
    upload: "Hochladen",
    clear: "Löschen",
    save: "Sparen",
    add: "Hinzufügen",
    email: "Email",
    password: "Passwort",
    password_confirmation: "Passwort bestätigen",
    first_name: "Vorname",
    last_name: "Nachname",
    code: "Code",
    resend: "Erneut senden",
    next: "Nächster",
    create: "Erstellen",
    edit: "Bearbeiten",
    cancel: "Stornieren",
    remove: "Löschen",
    hinge: "Scharnier",
    hinge_industry: "Beschläge",
    hinge_commission_fee: "Beschläge",
    glass: "Glas",
    glass_industry: "Glas",
    glass_commission_fee: "Glas",
    wood: "Holz",
    wood_industry: "Holz",
    wood_commission_fee: "Holz",
    metal_industry: "Metall",
    metal_commission_fee: "Metall",
    stone: "Stein",
    stone_industry: "Stein",
    stone_commission_fee: "Stein",
    metal: "Metall",
    name: "Name",
    city: "Ort",
    type: "Typ",
    id: "ID",
    phone_number: "Telefonnummer",
    street_name: "Straße",
    street_number: "Hausnummer",
    basic_info: "Basisinformation",
    bank_info: "Bankinformationen",
    address: "Adresse",
    zipcode: "Postleitzahl",
    state: "Bundesland",
    country: "Land",
    package_price: "Verpackung",
    transport_price: "Transportpreis pro zus. Einheit",
    start_transport_price: "Transport Grundpreis",
    glass_sizes: "Glasgrößen",
    min_width: "Min breite",
    max_width: "Maximale Breite",
    min_height: "Min Höhe",
    max_height: "Maximale Höhe",
    thickness: "Dicke",
    bank_account: "IBAN",
    bank_name: "Bank Name",
    bank_identifier_code: "BLZ/BIC",
    company: "Firma",
    product_class: "Produktklasse",
    commissions: "Provisionen",
    commission_fee: "Provisionsgebühr",
    active: "Aktiv",
    yes: "Ja",
    no: "Nein",
    filter: "Filter",
    items: "Kunden pro Seite",
    in_progress: "In Bearbeitung",
    accepted: "Akzeptiert",
    accept: "Akzeptieren",
    rejected: "Abgelehnt",
    reject: "Ablehnen",
    order_id: "Auftragsnummer",
    order_number: "Auftrag-Nr.",
    date: "Datum",
    status: "Status",
    user: "Nutzer",
    description: "Beschreibung",
    attachments: "Anlagen",
    paid_at: "Bezahlt bei",
    mark_as_paid: "Als bezahlt markieren",
    days: "Tage",
    delivery_time: "Lieferzeit",
    price: "Preis",
    eur: "€",
    prices: "Preise",
    price_with_commission: "Preis mit Provision",
    price_without_commission: "Preis ohne Provision",
    price_with_tax: "Preis mit MwSt",
    xml: "XML",
    dxf: "DXF",
    order: "Auftrag",
    order_for_fittings: "Beschlagsbestellung",
    invoice: "Rechnung",
    shapes: "Formen",
    preview: "Vorschau",
    download_xml: "XML Herunterladen",
    download_dxf: "DXF herunterladen",
    download_shapes: "Formen herunterladen",
    invoice_pdf: "Rechnung PDF",
    order_pdf: "Auftrag PDF",
    preview_pdf: "Vorschau PDF",
    order_for_fittings_pdf: "Bestellung für Armaturen PDF",
    tax_id: "ATU Nummer",
    tax: "MwSt",
    tax_for_services: "Steuer für Dienstleistungen",
    email_contacts: "E-Mail-Kontakte",
    min_size: "Min size",
    max_size: "Maximale Größe",
    min_diameter: "Mindestdurchmesser",
    max_diameter: "Max Durchmesser",
    min_surface_area: "Min Oberfläche",
    max_surface_area: "Max Oberfläche",
    edge_processing: "Kantenbearbeitung",
    hole_drilling: "Lochbohren",
    corner_cutout: "Eckausschnitt",
    inner_cutout: "Ausschnitte",
    corner_section: "Eckabschnitt",
    settings: "Die Einstellungen",
    available: "Verfügbar",
    industry: "Industrie",
    image: "Bild",
    variants: "Varianten",
    variant: "Variante",
    article_number: "Artikelnummer",
    all: "Alles",
    amount: "Menge",
    receipt: "Quittung",
    payments: "Zahlungen",
    special_user: "A Kunde",
    colors: "Farben",
    color: "Farbe",
    color_code: "Farbcode",
    color_id: "Farbe ID",
    filled: "Vollemail",
    framed: "Randemail",
    pattern: "Digitaldruck",
    width_from: "Breite von",
    width_to: "Breite bis",
    dimensions: "Maße",
    duplicate: "Duplikat",
    ep_required: "Kantenbearbeitung erforderlich",
    customer_number: "Kundennummer",
    successfully_registred: "Sie haben sich erfolgreich registriert",
    newly_users: "Neu registrierte Benutzer",
    characters: "Zeichen",
    suppliers: "Lieferanten",
    contact_person: "Ansprechperson",
    commissions: "Provisionen",
    few_products: "wenig Produkte freigegeben",
    all_products: "alle Produkte freigegeben",
    contact: "Kontakt",
    contacts: "Kontakte",
    files: 'Dateien',
    files_selected: '{number} Dateien ausgewählt',
    choose_files: 'Wähle Dateien...',
    category: 'Kategorie',
    infos: 'Infos',
    create_info: "Info erstellen",
    edit_info: "Bearbeitungs Info",
    author: 'Autor',
    branch: "Branchen",
    archive: 'Archiv',
    archived: 'Archiviert',
  }
};



// WEBPACK FOOTER //
// ./resources/nuxt/lang/de.js